import { action } from 'easy-peasy';
import { IActionSetMoreActivityLogs } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreActivityLogs: IActionSetMoreActivityLogs = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.length;

  const newItems = mergeUniqueBy(state.items, payload, item => item.patientId);

  state.items = [...newItems];
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreActivityLogs;
